import { __assign } from 'tslib';
import * as React from 'react';

/**
 * @description CoinStack icon component.
 *
 * @component
 * @example
 * ```jsx
 * import { CoinStack } from '@sravni/design-system-icons'
 *
 * <CoinStack />
 * ```
 */
var CoinStack = React.forwardRef(function (props, ref) { return (React.createElement("svg", __assign({ ref: ref, "data-qa": "CoinStack", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5.111 7.5c0-.345.28-.625.625-.625h6.667c.345 0 .625.28.625.625v3.333a.625.625 0 1 1-1.25 0V8.125H6.361v2.708a.625.625 0 1 1-1.25 0V7.5Z", fill: "currentColor" }),
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5.945 4.167c0-.346.28-.625.625-.625h6.667c.345 0 .625.28.625.625V7.5c0 .345-.28.625-.625.625h-.833a.625.625 0 0 1 0-1.25h.208V4.792H7.195V7.5a.625.625 0 0 1-1.25 0V4.167ZM15.152 12.251a2.708 2.708 0 1 0-3.83 3.83l-.439.439.439-.439a2.708 2.708 0 0 0 3.83 0l.442.442-.442-.442a2.708 2.708 0 0 0 0-3.83Zm.883-.884a3.958 3.958 0 1 0-5.598 5.598 3.958 3.958 0 0 0 5.599-5.598Z", fill: "currentColor" }),
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5.736 13.541c.346 0 .625.28.625.625v2.709h6.875a.625.625 0 0 1 0 1.25h-7.5a.625.625 0 0 1-.625-.625v-3.334c0-.345.28-.625.625-.625Z", fill: "currentColor" }),
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4.278 10.833c0-.345.28-.625.625-.625h8.334a.625.625 0 0 1 0 1.25H5.528v2.083h4.375a.625.625 0 0 1 0 1.25h-5a.625.625 0 0 1-.625-.625v-3.333Z", fill: "currentColor" }))); });

export { CoinStack };
//# sourceMappingURL=CoinStack.js.map
